import { SongPreview } from '~/interfaces';
import { ReactElement, ReactNode, useMemo } from 'react';
import { SongGroup } from '~/routes/SingASong/SongSelection/Hooks/useSongList';
import { AppliedFilters } from '~/routes/SingASong/SongSelection/Hooks/useSongListFilter';

export interface PlaylistEntry {
  name: string;
  display?: ReactNode;
  hideNew?: boolean;
  Wrapper?: (props: { children: ReactElement; focused: boolean; active: boolean }) => ReactNode;
  filters: AppliedFilters;
  groupData?: (song: SongPreview) => Pick<SongGroup, 'name' | 'displayShort' | 'displayLong'>;
  postGrouping?: (groups: SongGroup[]) => SongGroup[];
  sortingFn?: (a: SongPreview, b: SongPreview) => number;
  footerComponent?: ReactNode;
}

export const usePlaylists = (_songs: SongPreview[], _recommended: string[], isLoading: boolean): PlaylistEntry[] => {
  return useMemo<PlaylistEntry[]>(() => {
    if (isLoading) return [];

    return [
      { name: 'All', filters: {} },
      { name: 'Favoritos', filters: {} },
      { name: 'Playlist', filters: {} },
    ];
  }, [isLoading]);
};
